import React from "react";
import { makeStyles, Typography } from "@material-ui/core";

type AlbumType = {
  id?: string;
  name: string;
  coverPhoto: string;    // url da capa
  link?: string;         // link preferencial
  fbLink?: string;       // fallback
  itemsCount?: number;   // opcional: "26 itens"
};

export default function Album({ album }: { album: AlbumType }) {
  const classes = useStyles();
  const href = album.link ?? album.fbLink ?? "#";

  return (
    <div className={classes.root}>
      <a href={href} target="_blank" rel="noopener noreferrer" className={classes.card}>
        {/* wrapper 1:1 */}
        <div className={classes.thumb}>
          <img
            src={album.coverPhoto}
            alt={`Capa do álbum ${album.name}`}
            className={classes.img}
            loading="lazy"
          />
        </div>
      </a>

      <div className={classes.textBlock}>
        <Typography className={classes.title} title={album.name}>
          {album.name}
        </Typography>
        {typeof album.itemsCount === "number" && (
          <Typography className={classes.subtitle}>
            {album.itemsCount} {album.itemsCount === 1 ? "item" : "itens"}
          </Typography>
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  card: {
    width: "100%",
    display: "block",
    borderRadius: 12,
    overflow: "hidden",
    background: theme.palette.background.paper,
    boxShadow: "0 1px 2px rgba(0,0,0,.08)",
    transition: "transform .15s ease, box-shadow .15s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0,0,0,.15)",
      "& img": { transform: "scale(1.02)" },
    },
  },

  // caixa 1:1 (quadrado) – funciona em qualquer navegador
  thumb: {
    position: "relative",
    width: "100%",
    paddingTop: "100%", // 1:1
    background: "#111",
  },

  img: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",      // preenche sem distorcer
    objectPosition: "center",
    transition: "transform .2s ease",
    display: "block",
  },

  textBlock: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },

  title: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.type === "dark" ? "#fff" : "#111",
    lineHeight: 1.25,
    display: "-webkit-box",
    WebkitLineClamp: 2, // até 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },

  subtitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
  },
}));
